import React from "react";
import styled from "styled-components";
import PageHeader from "../../Utils/PageHeader";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";

const SkillWrapper = styled.section`
  margin-bottom: 40px;
  display: block;
  position: relative;
`;
const FlexContainer = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media screen and (max-width: 768px) {
    justify-content: space-between;
  }
`;
const Element = styled.div`
  margin: 10px 10px 10px 0;
  padding: 20px;
  width: 160px;
  height: 160px;
  border-radius: 5%;
  background: ${(props) => (props.theme === "dark" ? "#345B63" : "#fff")};
  color: ${(props) => (props.theme === "dark" ? "#fff" : "black")};
  border: ${(props) => (props.theme === "dark" ? "none" : "1px solid #f2f2f2")};
  box-shadow: ${(props) =>
    props.theme === "dark" ? "none" : "5px 5px 8px #e6e6e6"};
  text-align: center;
  &:hover {
    transform: translateY(3px);
    transition: 300ms;
  }
  img {
    height: 85px;
    width: 85px;
    display: inline-block;
    margin: auto;
  }
  div {
    margin-top: 10px;
  }
  @media screen and (max-width: 768px) {
    width: 44%;
  }
`;

const Skills = () => {
  const { mode } = React.useContext(ThemeContext);
  return (
    <SkillWrapper id="skills">
      <PageHeader theme={mode}>My Skills Section</PageHeader>
      <FlexContainer>
        <Element theme={mode}>
          <img src="https://iamhiimanshukr.netlify.app/html.svg" alt="Html" />
          <div>HTML</div>
        </Element>
        <Element theme={mode}>
          <img src="https://iamhiimanshukr.netlify.app/css.svg" alt="Css" />
          <div>CSS</div>
        </Element>
        <Element theme={mode}>
          <img
            src="https://iamhiimanshukr.netlify.app/js.svg"
            alt="Javascript"
          />
          <div>Javascript</div>
        </Element>
        <Element theme={mode}>
          <img src="https://iamhiimanshukr.netlify.app/react.svg" alt="React" />
          <div>React</div>
        </Element>
        <Element theme={mode}>
          <img src="https://iamhiimanshukr.netlify.app/redux.svg" alt="Redux" />
          <div>Redux</div>
        </Element>
        <Element theme={mode}>
          <img
            src="https://iamhiimanshukr.netlify.app/nodejs.svg"
            alt="NodeJS"
          />
          <div>NodeJS</div>
        </Element>
        <Element theme={mode}>
          <img
            src="	https://iamhiimanshukr.netlify.app/express.svg"
            alt="ExpressJS"
          />
          <div>ExpressJS</div>
        </Element>
        <Element theme={mode}>
          <img
            src="https://iamhiimanshukr.netlify.app/mongodb.svg"
            alt="MongoDB"
          />
          <div>MongoDB</div>
        </Element>
        <Element theme={mode}>
          <img
            src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png"
            alt="Github"
          />
          <div>Git</div>
        </Element>
        <Element theme={mode}>
          <img
            src="https://seeklogo.com/images/M/material-ui-logo-5BDCB9BA8F-seeklogo.com.png"
            alt="materialUI"
          />
          <div>Material UI</div>
        </Element>
        <Element theme={mode}>
          <img
            src="https://avatars.githubusercontent.com/u/20658825?s=200&v=4"
            alt="styled"
          />
          <div>Styled Component</div>
        </Element>
      </FlexContainer>
    </SkillWrapper>
  );

  // return (
  //   <SkillWrapper>
  //     <PageHeader>My Skills Section</PageHeader>
  //     <FlexContainer>
  //       <Element>
  //         <img
  //           src="https://iamhiimanshukr.netlify.app/react.svg"
  //           alt="logo-1"
  //         />
  //         <div>React</div>
  //       </Element>
  //       <Element>
  //         <img src="https://iamhiimanshukr.netlify.app/js.svg" alt="logo-1" />
  //         <div>Javascript</div>
  //       </Element>
  //       <Element>
  //         <img
  //           src="https://iamhiimanshukr.netlify.app/redux.svg"
  //           alt="logo-1"
  //         />
  //         <div>Redux</div>
  //       </Element>
  //       <Element>
  //         <img
  //           src="	https://iamhiimanshukr.netlify.app/nodejs.svg"
  //           alt="logo-1"
  //         />
  //         <div>Nodejs</div>
  //       </Element>
  //       <Element>
  //         <img
  //           src="https://iamhiimanshukr.netlify.app/mongodb.svg"
  //           alt="logo-1"
  //         />
  //         <div>MongoDB</div>
  //       </Element>
  //       <Element>
  //         <img
  //           src="	https://iamhiimanshukr.netlify.app/github.svg"
  //           alt="logo-1"
  //         />
  //         <div>Github</div>
  //       </Element>
  //     </FlexContainer>
  //   </SkillWrapper>
  // );
};

export default Skills;
